import annotationPoster from '../posters/annotation.webp';
import decorationsPoster from '../posters/decorations.webp';
import duplicatePoster from '../posters/duplicate.webp';
import farrangementsPanelPoster from '../posters/farrangements-panel.webp';
import furnituresPanelPoster from '../posters/furnitures-panel.webp';
import lookCameraControlsPoster from '../posters/look-camera-controls.webp';
import mapCameraControlsPoster from '../posters/map-camera-controls.webp';
import numberingPoster from '../posters/numbering.webp';
import orbitCameraControlsPoster from '../posters/orbit-camera-controls.webp';
import recorderPoster from '../posters/recorder.webp';
import rulerPoster from '../posters/ruler.webp';
import screenshotPoster from '../posters/screenshot.webp';
import selectPoster from '../posters/select.webp';
import splitViewPoster from '../posters/split-view.webp';
import streamingPoster from '../posters/streaming.webp';
import templatesPanelPoster from '../posters/templates-panel.webp';
import annotationVideo from '../videos/annotation.webm';
import decorationsVideo from '../videos/decorations.webm';
import duplicateVideo from '../videos/duplicate.webm';
import farrangementsPanelVideo from '../videos/farrangements-panel.webm';
import furnituresPanelVideo from '../videos/furnitures-panel.webm';
import lookCameraControlsVideo from '../videos/look-camera-controls.webm';
import mapCameraControlsVideo from '../videos/map-camera-controls.webm';
import numberingVideo from '../videos/numbering.webm';
import orbitCameraControlsVideo from '../videos/orbit-camera-controls.webm';
import recorderVideo from '../videos/recorder.webm';
import rulerVideo from '../videos/ruler.webm';
import screenshotVideo from '../videos/screenshot.webm';
import selectVideo from '../videos/select.webm';
import splitViewVideo from '../videos/split-view.webm';
import streamingVideo from '../videos/streaming.webm';
import templatesPanelVideo from '../videos/templates-panel.webm';

export const aidCatalog = {
  'orbit-camera-controls': {
    title: 'Dollhouse mode',
    description:
      'Move the 3D model by dragging, adjust your view zooming using the mouse wheel, bring your space closer by holding down the CTRL key while dragging with the mouse',
    src: orbitCameraControlsVideo,
    poster: orbitCameraControlsPoster,
  },
  'map-camera-controls': {
    title: 'Floorplan mode',
    description:
      'Use this mode to diagram. Zoom in and out with the wheel. Drag object in the scene. Create!',
    src: mapCameraControlsVideo,
    poster: mapCameraControlsPoster,
  },
  'look-camera-controls': {
    title: 'Walk mode',
    description:
      'Click on the space to move around. Use the mouse wheel to effortlessly zoom in and out.',
    src: lookCameraControlsVideo,
    poster: lookCameraControlsPoster,
  },
  'split-view': {
    title: 'Split View',
    description: 'Compare two different views of the same scene side by side.',
    src: splitViewVideo,
    poster: splitViewPoster,
  },
  duplicate: {
    title: 'Duplicate',
    description: 'Duplicate objects in the scene by dragging them.',
    src: duplicateVideo,
    poster: duplicatePoster,
  },
  ruler: {
    title: 'Measurement',
    description: 'Measure distance in the scene',
    src: rulerVideo,
    poster: rulerPoster,
  },
  annotation: {
    title: 'Annotation',
    description: 'Add annotations in the scene',
    src: annotationVideo,
    poster: annotationPoster,
  },
  select: {
    title: 'Multiselect',
    description:
      'Click on the furniture to select them on by one. Or holding down the SHIFT key and dragging with the mouse.',
    src: selectVideo,
    poster: selectPoster,
  },
  numbering: {
    title: 'Numbering',
    description: 'Number furniture in the scene by clicking on them.',
    src: numberingVideo,
    poster: numberingPoster,
  },
  'farrangements-panel': {
    title: 'Setup menu',
    description: 'Select setup and draw a box in the scene.',
    src: farrangementsPanelVideo,
    poster: farrangementsPanelPoster,
  },
  'furnitures-panel': {
    title: 'Furniture menu',
    description: 'Drag and drop a furniture to the scene.',
    src: furnituresPanelVideo,
    poster: furnituresPanelPoster,
  },
  'templates-panel': {
    title: 'Templates menu',
    description: 'Select template to apply to the scene.',
    src: templatesPanelVideo,
    poster: templatesPanelPoster,
  },
  'records-panel': {
    title: 'Recorder',
    description: 'Record the scene upon clicking on start recording and download it.',
    src: recorderVideo,
    poster: recorderPoster,
  },
  'streaming-panel': {
    title: 'Streaming',
    description: 'Stream live session with customer.',
    src: streamingVideo,
    poster: streamingPoster,
  },
  'share-panel': {
    title: 'Camera button',
    description: 'Take a screenshot of the scene and download it.',
    src: screenshotVideo,
    poster: screenshotPoster,
  },
  'decorations-panel': {
    title: 'Decorations menu',
    description: 'Drag and drop a decoration to the scene.',
    src: decorationsVideo,
    poster: decorationsPoster,
  },
  'real-time-sharing': {
    title: 'Real time sharing menu',
    description: 'Share your session with others.',
    src: decorationsVideo,
    poster: decorationsPoster,
  },
} as const;

export const getAidInfo = (id: keyof typeof aidCatalog) => aidCatalog[id];

export default aidCatalog;
